export const getDialogsPage = state => state.dialogsPage;
export const getMessages = state => state.dialogsPage.messages;

export const getDialogsData = state => state.dialogsPage.dialogsData;
export const getMessagesId = state => state.dialogsPage.messagesId;
